import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppShell } from '../components/layout/AppShell';
import { ConversationView } from '../components/conversation/ConversationView';
import { useConversations, useCreateConversation } from '../hooks/useConversations';

export function ChatPage() {
  const { conversationId } = useParams<{ conversationId: string }>();
  const navigate = useNavigate();
  const { data: convs, isLoading } = useConversations();
  const create = useCreateConversation();

  // If we land at "/" with no conversation selected, either pick the most-recent
  // or create a new one.
  useEffect(() => {
    if (conversationId) return;
    if (isLoading) return;
    if (!convs) return;
    if (convs.length > 0) {
      navigate(`/c/${convs[0].id}`, { replace: true });
      return;
    }
    if (!create.isPending && !create.isSuccess) {
      void create.mutateAsync('cfo').then((r) => navigate(`/c/${r.conversation.id}`, { replace: true }));
    }
  }, [conversationId, convs, isLoading, navigate, create]);

  return (
    <AppShell>
      {conversationId ? (
        <ConversationView conversationId={conversationId} />
      ) : (
        <div className="flex h-full items-center justify-center text-slate-400">Loading…</div>
      )}
    </AppShell>
  );
}
